<template>
  <div class="container">
    <div class="title">用户注销协议</div>
    <div class="content">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在您注销您的闪易账号之前，请充分阅读、理解并同意下列事项：<br>
      在此善意地提醒您，您注销本闪易账号的行为,将导致我们终止对您提供本服务，也会给您的售后维权带来诸多不便。注销成功后，我们将删除您的个人信息，使其保持不可被检索、访问的状态，或对其进行匿名化处理。您知晓并理解，依据相关法律法规规定或双方约定，我们仅会在实现法律规定或双方约定目的所必须的最短时间内留存您的相关个人信息。<br>
      1、如果您仍执意注销本闪易账号，您的闪易账号需同时满足以下条件：<br>
      &nbsp;&nbsp;&nbsp;&nbsp;(1)账号内无资产（包括不限于门锁、门禁等各类设备）、无欠款；<br>
      &nbsp;&nbsp;&nbsp;&nbsp;(2)账号内无未完成的订单、已提供服务但未支付的订单；<br>
      &nbsp;&nbsp;&nbsp;&nbsp;(3)账号无任何纠纷，包括投诉举报或被投诉举报；<br>
      &nbsp;&nbsp;&nbsp;&nbsp;(4)账号内无管理员身份；<br>
      &nbsp;&nbsp;&nbsp;&nbsp;(5)账号可正常使用中且无任何被限制的记录；<br>
      2、在闪易账号注销期间，如果您的闪易账号涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，我们有权自行终止闪易账号的注销而无需另行得到您的同意。<br>
      3、闪易账号一旦被注销将不可恢复，请您在操作之前自行备份闪易账号相关的所有信息和数据。注销闪易账号，您将无法再使用闪易账号，也将无法找回您闪易账号内所有历史记录信息(即使您使用相同的手机号码再次注册并使用)，包括但不限于<br>
      &nbsp;&nbsp;&nbsp;&nbsp;(1)您将无法登录、使用闪易账号；<br>
      &nbsp;&nbsp;&nbsp;&nbsp;(2)注销成功后将同步删除您的个人信息；<br>
      &nbsp;&nbsp;&nbsp;&nbsp;(3)闪易账号的个人资料和历史信息(包括但不限于用户名、昵称、头像等)都将无法找回；<br>
      &nbsp;&nbsp;&nbsp;&nbsp;(4)您通过闪易账号进行使用、授权登录或绑定闪易账号后的第三方服务的相关记录将无法找回。您将无法再登录、使用前述服务，您曾获得的虚拟权益等财产性利益将视为您自行放弃，将无法继续使用。<br>
      4、注销本闪易账号并不代表本闪易账号注销前的账号行为和相关责任得到豁免或减轻。<br>

    </div>
  </div>
</template>

<script>
export default {
  name: "Agreement",
  data() {
    return {};
  },
  mounted() {
    window.scroll(0,0)
  },
  methods: {}
}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.container {
  background-color: white;
  min-height: 100vh;
  position: relative;
}

.title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  margin-top: 5.3vw;
  color: #000000;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 5.3vw;

  font-size: 16px;
  color: #333333;
  line-height: 26px;
}
</style>
